import { TransactionStatus } from '../service-proxies';


export class CreateOrUpdateLeaveApplicationDto implements ICreateOrUpdateLeaveApplicationDto {
    id!: number | undefined;
    employeeId!: number;
    approverId!: number | undefined;
    leaveTypeId!: number;
    fromDateTime!: Date;
    toDateTime!: Date;
    leaveReason!: string | undefined;
    leaveStatus!: TransactionStatus;

    constructor(data?: ICreateOrUpdateLeaveApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.approverId = _data["approverId"];
            this.leaveTypeId = _data["leaveTypeId"];
            this.fromDateTime = _data["fromDateTime"] ? new Date(_data["fromDateTime"].toString()) : <any>undefined;
            this.toDateTime = _data["toDateTime"] ? new Date(_data["toDateTime"].toString()) : <any>undefined;
            this.leaveReason = _data["leaveReason"];
            this.leaveStatus = _data["leaveStatus"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLeaveApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLeaveApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["approverId"] = this.approverId;
        data["leaveTypeId"] = this.leaveTypeId;
        data["fromDateTime"] = this.fromDateTime ? this.fromDateTime.toISOString() : <any>undefined;
        data["toDateTime"] = this.toDateTime ? this.toDateTime.toISOString() : <any>undefined;
        data["leaveReason"] = this.leaveReason;
        data["leaveStatus"] = this.leaveStatus;
        return data; 
    }
}

export interface ICreateOrUpdateLeaveApplicationDto {
    id: number | undefined;
    employeeId: number;
    approverId: number | undefined;
    leaveTypeId: number;
    fromDateTime: Date;
    toDateTime: Date;
    leaveReason: string | undefined;
    leaveStatus: TransactionStatus;
}

